import init from './game';

window.addEventListener("load", init);